import _objectSpread from "@babel/runtime/helpers/objectSpread2";
import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["component"];
import React, { memo } from 'react';
import BaseMarketplaceImpression from './base-impression';
import KetoProductCard from '../../keto-product-card';
import MarketplaceProductCard from '../../marketplace-product-card';
/**
 * ImpressionContext can result in many rerenders of the card.
 */

var MemoizedMarketplaceProductCard = /*#__PURE__*/memo(MarketplaceProductCard);
var MemoizedKetoProductCard = /*#__PURE__*/memo(KetoProductCard);

/**
 * Underlying Marketplace impression used by the "keto" and "marketplace" product cards.
 * @private
 */
var MarketplaceImpression = function MarketplaceImpression(_ref) {
  var Component = _ref.component,
      props = _objectWithoutProperties(_ref, _excluded);

  var analytics = props.analytics,
      marketplaceEntity = props.marketplaceEntity,
      trkElementPosition = props.trkElementPosition,
      trkSectionCategory = props.trkSectionCategory,
      trkSectionPosition = props.trkSectionPosition;
  return /*#__PURE__*/React.createElement(BaseMarketplaceImpression, {
    productImpressionProps: analytics === null || analytics === void 0 ? void 0 : analytics.productImpressionProps,
    marketplaceEntity: marketplaceEntity,
    trkSectionCategory: trkSectionCategory,
    trkSectionPosition: trkSectionPosition,
    trkElementPosition: trkElementPosition
  }, /*#__PURE__*/React.createElement(Component, props));
};
/**
 * The KetoProductCard wrapped with an Impression.
 */


export var KetoProductCardImpression = function KetoProductCardImpression( // @ts-ignore - ignoring implicit any type since it's a wrapper
props // eslint-disable-line @typescript-eslint/explicit-module-boundary-types
) {
  return /*#__PURE__*/React.createElement(MarketplaceImpression, _extends({}, props, {
    component: MemoizedKetoProductCard
  }));
};
/**
 * The MarketplaceProductCard wrapped with an Impression.
 */

export var MarketplaceProductCardImpression = function MarketplaceProductCardImpression( // @ts-ignore - ignoring implicit any type since it's a wrapper
props // eslint-disable-line @typescript-eslint/explicit-module-boundary-types
) {
  return /*#__PURE__*/React.createElement(MarketplaceImpression, _extends({}, props, {
    component: MemoizedMarketplaceProductCard
  }));
};

if (process.env.NODE_ENV !== 'production') {
  /* eslint-disable global-require, react/forbid-prop-types, @typescript-eslint/no-var-requires */
  var PropTypes = require('prop-types');

  var _ = require('lodash');

  var _require = require('../../prop-types'),
      AnalyticsPropType = _require.AnalyticsPropType,
      KetoProductCardAnalyticsPropType = _require.KetoProductCardAnalyticsPropType,
      MarketplaceProductCardAnalyticsPropType = _require.MarketplaceProductCardAnalyticsPropType;

  MarketplaceImpression.propTypes = {
    analytics: PropTypes.shape({
      productImpressionProps: AnalyticsPropType
    }),
    component: PropTypes.elementType.isRequired,
    marketplaceEntity: PropTypes.object.isRequired,
    showBestOfAwards: PropTypes.bool,
    productImpressionProps: PropTypes.object,
    trkElementPosition: PropTypes.number,
    trkSectionCategory: PropTypes.string,
    trkSectionPosition: PropTypes.number
  };
  KetoProductCardImpression.propTypes = _objectSpread(_objectSpread({}, _.omit(MarketplaceImpression.propTypes, 'component')), {}, {
    analytics: KetoProductCardAnalyticsPropType
  });
  MarketplaceProductCardImpression.propTypes = _objectSpread(_objectSpread({}, _.omit(MarketplaceImpression.propTypes, 'component')), {}, {
    analytics: MarketplaceProductCardAnalyticsPropType
  });
  /* eslint-enable global-require, react/forbid-prop-types, @typescript-eslint/no-var-requires */
}